import filterCannotContinue from 'app/beta-editor/utils/filterCannotContinue';

import pathSettingsBehavior from './pathSettings';

import { RequiredBehaviors } from 'app/beta-editor/pages/types';

const pathRulesBehavior: RequiredBehaviors = {
  ...pathSettingsBehavior,
  label: () => 'Rules Setup & Testing',
  menuLabel: props => pathRulesBehavior.label(props),
  crumbLabel: () => 'Rules',
  status: ({ node }) => (filterCannotContinue(node) ? '' : 'success'),
};

export default pathRulesBehavior;
